webpackJsonp([25],{

/***/ "uDZf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.mjs
var preact = __webpack_require__("OmAK");

// EXTERNAL MODULE: ../node_modules/preact-helmet/lib/Helmet.js
var Helmet = __webpack_require__("FJnM");
var Helmet_default = /*#__PURE__*/__webpack_require__.n(Helmet);

// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__("9qb7");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ../node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__("/uc1");

// EXTERNAL MODULE: ./environment.ts
var environment = __webpack_require__("evTo");

// EXTERNAL MODULE: ./shared/factories/appConfig.factory.ts
var appConfig_factory = __webpack_require__("woKH");

// CONCATENATED MODULE: ./components/ErrorPage/ErrorPage.tsx
var ErrorPage__a;






var BrandErrorPageContent = (ErrorPage__a = {},
    ErrorPage__a[environment["b" /* Brand */].GRUBHUB] = {
        header: "Looks like we're missing something",
        lead: "We couldn't cook up the page you were looking for because it doesn't exist.",
        backButton: 'Return to the homepage',
    },
    ErrorPage__a[environment["b" /* Brand */].SEAMLESS] = {
        header: 'Oops',
        lead: 'So sorry, but it looks like things got sidetracked on the way to food time. Romaine calm and lettuce get you back to the homepage.',
        backButton: 'Return to the homepage',
    },
    ErrorPage__a);
function ErrorPage(_a) {
    var headerText = _a.headerText, leadText = _a.leadText, backButtonText = _a.backButtonText, backButtonUrl = _a.backButtonUrl, _b = _a.errorCode, errorCode = _b === void 0 ? '404' : _b;
    var brand = Object(appConfig_factory["a" /* appConfigFactory */])().brand;
    var content = BrandErrorPageContent[brand];
    var header = headerText || content.header;
    var lead = leadText || content.lead;
    var backText = backButtonText || content.backButton;
    var backUrl = backButtonUrl || '/';
    return (Object(preact["h"])("div", { className: classnames_default()('error-page', 'u-section-6', {
            'error-page--grubhub': brand === environment["b" /* Brand */].GRUBHUB,
            'error-page--seamless': brand === environment["b" /* Brand */].SEAMLESS,
        }) },
        Object(preact["h"])(Helmet_default.a, { meta: [{ name: 'prerender-status-code', content: '404' }] }),
        Object(preact["h"])("div", { class: "error-page__reason u-stack-y-4" },
            Object(preact["h"])("h1", { class: "error-page__reason-header u-stack-y-6" }, header),
            Object(preact["h"])("p", { class: "lead u-stack-y-8" }, lead),
            Object(preact["h"])("p", { class: "u-stack-y-6" },
                Object(preact["h"])(react_router_dom["c" /* Link */], { to: backUrl, title: backText, class: "s-btn s-btn-primary" }, backText)),
            Object(preact["h"])("p", { class: "caption" }, "Error code: " + errorCode)),
        Object(preact["h"])("div", { className: "error-page__image" })));
}

// CONCATENATED MODULE: ./components/ErrorPage/index.ts
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ErrorPage", function() { return ErrorPage; });



/***/ })

});


// WEBPACK FOOTER //
// 25.chunk.1911a.js